

































import Vue from "vue";
// @ts-ignore
import { SwipeList } from "vue-swipe-actions";
import { Meldung } from "@/types";

import "vue-swipe-actions/dist/vue-swipe-actions.css";
import SkeletonItem from "@/components/ui/SkeletonItem.vue";

export default Vue.extend({
  name: "SwipeListContainer",
  components: {
    SwipeList,
    SkeletonItem,
  },
  props: {
    items: {
      type: Array as () => Meldung[],
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    swipeItems(): Meldung[] {
      return this.loading ? ([{}, {}, {}] as Meldung[]) : this.items;
    },
  },
  methods: {
    onClick(item: Object) {
      this.$emit("click", item);
    },
    onDelete(item: Object) {
      this.$emit("delete", item);
    },
    setAsRead(item: Object) {
      this.$emit("read", item);
    },
    onProtocol(item: Object) {
      this.$emit("protocol", item);
    },
  },
});
